import React, { useState, useRef } from "react";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from "primereact/checkbox";
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Route } from 'react-router-dom';
import { addLocale, locale } from 'primereact/api';

import "./styles.css";

addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
});

// Ativa o locale
locale('pt-BR');

const PreConfiguracao = ({ questionario, setQuestionario, setFluxoGerenciamento }) => {

    //hooks react
    const [selectedNivelEnsino, setSelectedNivelEnsino] = useState(questionario.filtrosParticipante.nivelEnsino);
    const [selectedTurno, setSelectedTurno] = useState(questionario.filtrosParticipante.turno);

    //Constantes para elementos input
    const segmento = [
        { name: 'Egresso', code: 'EGRESSO' },
        { name: 'Discente', code: 'DISCENTE' },
        { name: 'Docente', code: 'DOCENTE' },
        { name: 'Técnico Administrativo', code: 'TÉCNICO_ADMINISTRATIVO' },
        { name: 'Gestor', code: 'GESTOR' },
        { name: 'Sociedade Civil', code: 'SOCIEDADE_CIVIL' }
    ];

    const nivelEnsino = ['Graduacao', 'Pos-graduacao'];
    const turno = ['Diurno', 'Matutino', 'Noturno', 'Vespertino', 'EAD'];

    
    function updateSegmentoDasQuestoes(grupo, novoSegmento) {
        return grupo.questoes.map((questao) => ({
          ...questao,
          segmentos: novoSegmento,
        }));
    }

    //functions para atribuir valores dos inputs ao modelo questionario
    const setPeriodoLetivoChange = (value) => {
        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            periodoLetivo: value,
        }));
    };

    const setInicioAplicacao = (value) => {
        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            inicioAplicacao: value,
        }));
    };

    const setTerminoAplicacao = (value) => {
        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            terminoAplicacao: value,
        }));
    };

    const setSegmento = (value) => {
        const filtrosParticipante = questionario.filtrosParticipante;
        filtrosParticipante.segmento = [value.code];

        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            filtrosParticipante: filtrosParticipante,
            gruposQuestoes: prevQuestionario.gruposQuestoes.map((grupo) => ({
              ...grupo,
              questoes: updateSegmentoDasQuestoes(grupo, filtrosParticipante.segmento),
            })),
        }));
    };

    const setNivelEnsino = (e) => {
        let _selectedNivelEnsino = questionario.filtrosParticipante.nivelEnsino;

        if (_selectedNivelEnsino.includes(e.value)) {
            const index = _selectedNivelEnsino.indexOf(e.value);
            _selectedNivelEnsino.splice(index, 1);
        } else {
            _selectedNivelEnsino.push(e.value);
        }

        setSelectedNivelEnsino(_selectedNivelEnsino);

        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            filtrosParticipante: {
                ...prevQuestionario.filtrosParticipante,
                nivelEnsino: selectedNivelEnsino,
            },
        }));
    };

    const setTurno = (e) => {
        let _selectedTurno = questionario.filtrosParticipante.turno;

        if (_selectedTurno.includes(e.value)) {
            const index = _selectedTurno.indexOf(e.value);
            _selectedTurno.splice(index, 1);
        } else {
            _selectedTurno.push(e.value);
        }

        setSelectedTurno(_selectedTurno);

        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            filtrosParticipante: {
                ...prevQuestionario.filtrosParticipante,
                turno: selectedTurno,
            },
        }));
    };

    const getEscalaDescriptions = (escalaAvaliativa) => {
        const valoresQualitativos = escalaAvaliativa.map(objeto => {
            const valor = objeto.valorQualitativo.toLowerCase();
            return valor.charAt(0).toUpperCase() + valor.slice(1);
        });
    
        const descricoes = valoresQualitativos.map((objeto, index) => (
            <React.Fragment key={index}>
                {index + 1} - {objeto}
                <br />
            </React.Fragment>
        ));
    
        return descricoes;
    };

    const toast = useRef(null);

    // Função para exibir um aviso de erro
    const showErrorToast = (message) => {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: message });
    };

    //renderização dos componentes da pagina
    return (
        <div className="questionario-etapa-prepos" style={{marginTop: '0px'}}>
            <Card title="Pré-Configurações">
                <p className="m-0">
                    <div className="dados">
                        <div className="colum-1">
                            <label className="atributo">Período Letivo*</label>
                            <InputMask id="input" value={questionario.periodoLetivo} onChange={(e) => setPeriodoLetivoChange(e.target.value)} mask="9999.9" placeholder="YYYY.1 ou YYYY.2"/>
                            <label className="atributo">Inicio da Aplicação</label>
                            <Calendar id="input-data" value={new Date(questionario.inicioAplicacao)} dateFormat="dd/mm/yy" onChange={(e) => setInicioAplicacao(e.value)} touchUI />
                            <label className="atributo">Termino da Aplicação</label>
                            <Calendar id="input-data" value={new Date(questionario.terminoAplicacao)} dateFormat="dd/mm/yy" onChange={(e) => setTerminoAplicacao(e.value)} touchUI />
                        </div>
                        <div className="colum-2">
                            <label className="atributo">Segmento*</label>
                            <Dropdown value={questionario.filtrosParticipante.segmento[0]} onChange={(e) => setSegmento(e.value)} options={segmento} optionLabel="name"
                            showClear placeholder={questionario.filtrosParticipante.segmento[0]} className="w-full md:w-14rem" />
                            <div className="escala">
                                <label className="atributo">Escala Avaliativa</label>
                                <Tag severity="success" value={questionario.escala.title} style={{ backgroundColor: '#4caf50', width: 'fit-content' }}></Tag> 
                                <label style={{ marginLeft: '5px', fontStyle: 'italic', fontSize: '14px', color: 'gray' }}>{getEscalaDescriptions(questionario.escala.escalaAvaliativa)}</label> 
                            </div>
                        </div>
                        <div className="colum-3">
                        <label className="atributo">Nível de Ensino*</label>
                            <div className="flex flex-column gap-3">
                                {nivelEnsino.map((category) => {
                                    return (
                                        <div key={category} className="flex align-items-center">
                                            <Checkbox inputId={category} name={category} value={category} onChange={setNivelEnsino} checked={selectedNivelEnsino.some((item) => item === category)} />
                                            <label htmlFor={category} className="ml-2">
                                                {category}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                            <label className="atributo" style={{marginTop: '25px'}}>Turno</label>
                            <div className="flex flex-column gap-3">
                                {turno.map((category) => {
                                    return (
                                        <div key={category} className="flex align-items-center">
                                            <Checkbox inputId={category} name={category} value={category} onChange={setTurno} checked={selectedTurno.some((item) => item === category)} />
                                            <label htmlFor={category} className="ml-2">
                                                {category}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <Route render={(props) => (
                        <div className="botoes">
                            <Button className='p-button-danger' label='RETROCEDER' icon='pi pi-arrow-left' onClick={() => {
                                props.history.push({
                                    pathname: '/questionarios',
                                });
                            }} />
                            <Button className='p-button-success' label='AVANÇAR' icon='pi pi-arrow-right' iconPos="right" style={{background: "#4caf50" }} onClick={() => {
                                let segmentoExiste = questionario.filtrosParticipante.segmento && questionario.filtrosParticipante.segmento.length > 0;
                                let nivelEnsinoExiste = questionario.filtrosParticipante.nivelEnsino && questionario.filtrosParticipante.nivelEnsino.length > 0;
                                let periodoAplicacaoValido = questionario.inicioAplicacao && questionario.terminoAplicacao && new Date(questionario.inicioAplicacao) >= new Date(questionario.terminoAplicacao);
                                const periodoLetivoRegex = /^\d{4}\.(1|2)$/;

                                if (!(segmentoExiste && nivelEnsinoExiste && periodoLetivoRegex.test(questionario.periodoLetivo))) {
                                    showErrorToast('Por favor, preencha todos os campos obrigatórios no formato correto.');
                                } else if (periodoAplicacaoValido) {
                                    showErrorToast('Período de aplicação invalido, data de término antes do Inicio');
                                } else {
                                    setFluxoGerenciamento('InicioConfigQ');
                                }
                            }} />
                        </div>
                    )} />
                </p>
                <Toast ref={toast} />
            </Card>
        </div>
    )
};

export default PreConfiguracao;